import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { FaCheck, FaSpinner } from 'react-icons/fa';
import logo2 from '../../../img/logo.png';
import LiveDate from '../LiveDate';

function RSVPForm({ weddingDate, startTime, endTime, fontP, walimatulurus, groomName, brideName, directions }) {
  const { id } = useParams();
  const cardId = id;

  const [name, setName] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [email, setEmail] = useState('');
  const [guests, setGuests] = useState('1');
  const [attending, setAttending] = useState(true);
  const [ucapan, setUcapan] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [initializing, setInitializing] = useState(true);
  const [emailEnabled, setEmailEnabled] = useState(1);
  const [limitRsvp, setLimitRsvp] = useState(0);
  const [error, setError] = useState('');

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_BASE_URL}/clients/${id}`)
      .then((response) => {
        setEmailEnabled(response.data.email_input);
        setLimitRsvp(response.data.limit_rsvp || 0);
      })
      .catch((error) => {
        console.error('Error fetching data:', error);
      })
      .finally(() => {
        setInitializing(false);
      });
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();

    const guestCount = parseInt(guests || '0');
    if (limitRsvp > 0 && guestCount > limitRsvp) {
      setError(`Maksimum jumlah tetamu yang dibenarkan ialah ${limitRsvp}.`);
      return;
    }

    setLoading(true);
    setError('');

    axios
      .post(`${process.env.REACT_APP_API_BASE_URL}/addrsvp`, {
        cardId,
        name,
        phoneNumber,
        email,
        guests: guestCount,
        attending,
        ucapan,
        checkedIn: 0,
      })
      .then((response) => {
        setMessage('RSVP anda telah disahkan!');
        setName('');
        setPhoneNumber('');
        setEmail('');
        setGuests('');
        setAttending(true);
        setSubmitted(true);
        setUcapan('');
        setLoading(false);
      })
      .catch((error) => {
        console.error('Error submitting RSVP:', error);
        setSubmitted(true);
        setLoading(false);
        setMessage(`Maaf. RSVP tidak berjaya. Boleh cuba sekali lagi`);
      });
  };

  return (
    <div>
      {(initializing || loading) ? (
        <div className="fixed inset-0 flex flex-col items-center justify-center space-y-5 bg-white z-50">
          <FaSpinner className="text-4xl text-black animate-spin" />
          <img src={logo2} alt="Logo" className="h-12 mb-4" />
        </div>
      ) : (
        <div>
          {submitted ? (
            <div className="max-w-lg mx-auto p-4 flex flex-col justify-center items-center">
              <div className="flex justify-center mb-4">
                <div className="bg-green-100 text-green-600 rounded-full p-3">
                  <FaCheck className="w-8 h-8" />
                </div>
              </div>
              <h1 className="text-2xl font-bold text-gray-800 mb-2">Terima Kasih!</h1>
              <p className="text-gray-600 text-sm">{message || 'RSVP anda telah disahkan!'}</p>
              <div className='pt-8 mt-8 border-t space-y-8'>
                <h2 className='text-2xl text-center'>Save The Date</h2>
                <LiveDate
                  weddingDate={weddingDate}
                  startTime={startTime}
                  endTime={endTime}
                  fontP={fontP}
                  walimatulurus={walimatulurus}
                  groomName={groomName}
                  brideName={brideName}
                  directions={directions}
                />
              </div>
            </div>
          ) : (
            <div className="max-w-lg mx-auto p-4">
              <h2 className="text-2xl font-semibold mb-4">RSVP</h2>
              <form onSubmit={handleSubmit}>
                {error && (
                  <div className="bg-red-200 text-red-800 py-2 px-4 rounded mb-4">
                    {error}
                  </div>
                )}
                <div className="mb-4">
                  <label className="block text-gray-700">Nama:</label>
                  <input
                    type="text"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    placeholder='Masukkan nama anda'
                    className="w-full border rounded py-2 px-3 focus:outline-none focus:ring focus:border-blue-300"
                    required
                  />
                </div>
                <div className="mb-4">
                  <label className="block text-gray-700">Nombor Telefon:</label>
                  <input
                    type="tel"
                    value={phoneNumber}
                    onChange={(e) => setPhoneNumber(e.target.value)}
                    placeholder='Masukkan no telefon anda'
                    className="w-full border rounded py-2 px-3 focus:outline-none focus:ring focus:border-blue-300"
                    required
                  />
                </div>
                {emailEnabled ? (
                  <div className="mb-4">
                    <label className="block text-gray-700">Email:</label>
                    <input
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder='Masukkan email anda'
                      className="w-full border rounded py-2 px-3 focus:outline-none focus:ring focus:border-blue-300"
                      required
                    />
                  </div>
                ) : null}
                <div className="mb-4">
                  <label className="block text-gray-700">Jumlah Tetamu:</label>
                  {limitRsvp > 0 ? (
                    <select
                      value={guests}
                      onChange={(e) => setGuests(e.target.value)}
                      className="w-full border rounded py-2 px-3 focus:outline-none focus:ring focus:border-blue-300"
                      required
                    >
                      {[...Array(limitRsvp)].map((_, i) => (
                        <option key={i + 1} value={i + 1}>
                          {i + 1}
                        </option>
                      ))}
                    </select>
                  ) : (
                    <input
                      type="number"
                      min="1"
                      value={guests}
                      onChange={(e) => setGuests(e.target.value)}
                      placeholder="Masukkan jumlah tetamu"
                      className="w-full border rounded py-2 px-3 focus:outline-none focus:ring focus:border-blue-300"
                      required
                    />
                  )}
                </div>
                <div className="mb-4">
                  <label className="block text-gray-700">Hadir atau Tidak Hadir?</label>
                  <select
                    value={attending}
                    onChange={(e) => setAttending(e.target.value === 'true')}
                    className="w-full border rounded py-2 px-3 focus:outline-none focus:ring focus:border-blue-300"
                    required
                  >
                    <option value={true}>Hadir</option>
                    <option value={false}>Tidak Hadir</option>
                  </select>
                </div>
                <div className="mb-4">
                  <label className="block text-gray-700">Ucapan (jika ada):</label>
                  <textarea
                    value={ucapan}
                    onChange={(e) => setUcapan(e.target.value)}
                    placeholder='Tulis ucapan anda di sini...'
                    className="w-full border rounded py-2 px-3 focus:outline-none focus:ring focus:border-blue-300"
                  />
                </div>
                <button
                  type="submit"
                  className="btn-primary py-2 px-4 rounded"
                >
                  Hantar RSVP
                </button>
              </form>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default RSVPForm;
